import TextOverflow from '../TextOverflow';
import styles from './styles.module.scss';

export interface IDescriptionProps {
  children: string;
}

const Description = ({ children }: IDescriptionProps) => {
  return (
    <TextOverflow className={styles.description} asComponent='p'>
      {children}
    </TextOverflow>
  );
};

export default Description;
